import {Type} from '@angular/core';

export const tableButtonTypes: { [key: string]: any } = {};

export function GnTableButton(key: string) {
  return (target: Type<any>) => {
    tableButtonTypes[key] = target;
  };
}
